module.exports = __webpack_public_path__ + "img/payment-footer.3ac8ab0c.png";